import { createContext, useState } from "react";
import type {
  IHospital,
  IHospitalsContextData,
  IHospitalsProviderProps,
} from "./types";
import { createHospitalUtils } from "./utils";
import Loading from "../../components/Shared/Loading";

export const HospitalsContext = createContext<IHospitalsContextData | null>(
  null,
);

export const HospitalsProvider = ({ children }: IHospitalsProviderProps) => {
  const [isLoading, _setIsLoading] = useState(false);
  const [hospitalsList, setHospitalsList] = useState<IHospital[]>([]);

  const contextValue: IHospitalsContextData = {
    hospitalsList,
    setHospitalsList,
    ...createHospitalUtils(),
  };

  return (
    <HospitalsContext.Provider value={contextValue}>
      {isLoading && <Loading />}
      {children}
    </HospitalsContext.Provider>
  );
};
